/* eslint-disable import/prefer-default-export */
/**
 * Helper method to toggle class names
 *
 * @param      {<type>}  classList  The class list
 */
export function toggleClass(classList) {
  if (classList.contains('open')) {
    classList.remove('open');
  } else {
    classList.add('open');
  }
}

/**
 * Polyfill for parents method
 * @param {*} selector
 */
function parents(selector) {
  const elements = [];
  let elem = this;
  const ishaveselector = selector !== undefined;

  while ((elem = elem.parentElement) !== null) { //eslint-disable-line
    if (elem && elem.nodeType !== Node.ELEMENT_NODE) {
      continue; //eslint-disable-line
    }

    if (!ishaveselector || (elem && elem.matches(selector))) {
      elements.push(elem);
    }
  }

  return elements;
}

Element.prototype.parents = parents;


/**
 * Dropdown Handler
 *
 * @param      {<type>}  event   The event
 */
function dropdownHandlerToOpen(event) {
  const dropdownField = document.querySelectorAll('.g-drop-common.g-dropdown-wrap');
  const targetParent = event.target.parents('.g-drop-common.g-dropdown-wrap');
  const ignoreIt = event.target.parents('.g-drop-common.g-dropdown-wrap .ignore-click');

  dropdownField.forEach((ele) => {
    if (ele === targetParent[0]) return;
    ele.classList.remove('open');
  });

  if (!ignoreIt.length && !event.target.classList.contains('ignore-click') && targetParent.length) {
    toggleClass(targetParent[0].classList);
  }
}

if (document.addEventListener) {
  document.body.addEventListener('click', dropdownHandlerToOpen);
}
